import { frontendURL } from '../../../../helper/URLHelper';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import CreateTemplatePage from '../inbox/CreateTemplatePage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_templates',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/templates'),
      component: SettingsContent,
      // Not kept alive: a template submitted from here should not come back as a filled-in draft.
      props: { keepAlive: false },
      children: [
        {
          path: 'new',
          name: 'settings_templates_new',
          component: CreateTemplatePage,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
